import React from "react";

type ClientNotesIndicatorProps = {
  tooltip: string;
  ariaLabel: string;
  className?: string;
  onOpen?: () => void;
  preview?: string | null;
};

const ClientNotesIndicator: React.FC<ClientNotesIndicatorProps> = ({
  tooltip,
  ariaLabel,
  className = "ri-sticky-note-line text-warning ms-2 flex-shrink-0",
  onOpen,
  preview,
}) => {
  const stop = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  if (onOpen) {
    return (
      <button
        type="button"
        className="btn btn-link p-0 border-0 align-baseline text-decoration-none d-inline-flex align-items-center gap-1"
        title={tooltip}
        aria-label={ariaLabel}
        onMouseDown={stop}
        onClick={(event) => {
          stop(event);
          onOpen();
        }}
      >
        <i className={className.replace(/\bms-2\b/, "").trim() || "ri-sticky-note-line text-warning"} aria-hidden="true" />
        {preview ? (
          <span className="text-warning small text-truncate" style={{ maxWidth: 140 }} data-clarity-mask="true">
            {preview}
          </span>
        ) : null}
      </button>
    );
  }

  return (
    <i
      className={className}
      title={tooltip}
      aria-label={ariaLabel}
      onMouseDown={stop}
    />
  );
};

export default ClientNotesIndicator;
